import EventsApi from "../../../api/events-api";
import { EventTypes } from "../../../constants/event_types";
import i18n from '../../../plugins/i18n';

export default {
  name: "AddNoteModal",

  props: { cow: Object, isModalOpen: Boolean, reload: Function },

  data() {
    return {
      date: this.$moment(),
      maxDate: this.$moment(),
      notes: null,
      errors: {},
      serverError: null
    };
  },
  methods: {
    flushErrors() {
      this.errors = {};
    },
    validate() {
      this.flushErrors();

      if (!this.notes || this.notes === "") {
        this.errors.notes = i18n.t('addNote.errors.noteRequired');
      }

      if (this.$moment(this.date).isAfter(this.maxDate)) {
        this.errors.date = i18n.t('addNote.errors.futureDate');
      }

      if (this.$refs.noteTimePicker.error) {
        return false;
      }

      if (Object.keys(this.errors).length > 0) {
        return false;
      }
      return true;
    },
    async save() {
      // Validate form data before save
      const isValidForm = this.validate();
      if (!isValidForm) return;

      const dataToSend = {
        cow_id: this.cow.cow_id,
        event_type: EventTypes.Note,
        event_time: this.$moment(this.date).format(),
        notes: this.notes
      }

      // Set loading and wait for data to be sent and response to be returned.
      const response = await EventsApi.post(dataToSend);

      if (response.status === 200) {
        this.reload();
        this.close();
      } else if (response.data && response.data.error) {
        this.serverError = {
          error: response.data.error.error,
          message: response.data.error.message
        };
      }
    },
    close() {
      this.$emit("close");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_modals/add-note/add-note-modal.js